export default class DeliverectChannelRegistrationBodyRequest {
    status: string;
    channelLocationId: string;
    channelLinkId: string;
    locationId: string;
    channelLinkName: string;

    constructor() {
        this.status = '';
        this.channelLocationId = '';
        this.channelLinkId = '';
        this.locationId = '';
        this.channelLinkName = '';
    }

    static fromJson(json: any): DeliverectChannelRegistrationBodyRequest {
        let result = new DeliverectChannelRegistrationBodyRequest();
        result.status = json.status;
        result.channelLocationId = json.channelLocationId;
        result.channelLinkId = json.channelLinkId;
        result.locationId = json.locationId;
        result.channelLinkName = json.channelLinkName;
        return result;
    }
}